import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createBlock as _createBlock, Transition as _Transition, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/payments/bono-negro.svg'
import _imports_1 from '@/assets/images/payments/credit-card-negra.svg'
import _imports_2 from '../assets/images/arrow-prev.svg'
import _imports_3 from '../assets/images/cards/visasecureblue.png'
import _imports_4 from '../assets/images/cards/mc_idcheck.svg'


const _withScopeId = n => (_pushScopeId("data-v-142d0d01"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modalPayment pl-2 pr-2 mt-2" }
const _hoisted_2 = { class: "relative h-full" }
const _hoisted_3 = {
  key: 0,
  class: "mb-4 sm:text-sm mt-2"
}
const _hoisted_4 = {
  key: 1,
  class: "mt-2"
}
const _hoisted_5 = { class: "flex items-center" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "w-16 h-10 bg-white flex justify-center items-center mr-4 p-3 br8" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  })
], -1))
const _hoisted_7 = { class: "playerSubtitle" }
const _hoisted_8 = {
  key: 0,
  class: "flex items-center bg-orange-500 text-white text-xs px-4 py-3 mt-2 fade-in-image",
  role: "alert",
  style: {"border-radius":"28px"}
}
const _hoisted_9 = {
  key: 2,
  class: "mt-2"
}
const _hoisted_10 = { class: "flex items-center" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "w-16 h-10 bg-white flex justify-center items-center mr-4 p-3 br8" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    alt: ""
  })
], -1))
const _hoisted_12 = { class: "playerSubtitle" }
const _hoisted_13 = { key: 3 }
const _hoisted_14 = { class: "flex items-center" }
const _hoisted_15 = { class: "w-16 h-10 bg-white flex justify-center items-center mr-4 p-3 br8" }
const _hoisted_16 = ["alt", "src"]
const _hoisted_17 = { class: "playerSubtitle" }
const _hoisted_18 = { class: "playerSubtitle" }
const _hoisted_19 = ["onClick"]
const _hoisted_20 = { class: "mt-8 w-full wrapperBottomWallet" }
const _hoisted_21 = { class: "flex justify-between mb-4" }
const _hoisted_22 = { class: "flex justify-center items-center sm:text-sm" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "w-6 h-6 flex justify-center items-center" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "arrowPolicy",
    src: _imports_2,
    alt: ""
  })
], -1))
const _hoisted_24 = { class: "text-xs mt-4" }
const _hoisted_25 = {
  key: 1,
  class: "flex items-center bg-blue-500 text-white text-xs px-4 py-3 mt-2",
  role: "alert",
  style: {"border-radius":"28px"}
}
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "fill-current w-6 h-6 mr-2",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M12.432 0c1.34 0 2.01.912 2.01 1.957 0 1.305-1.164 2.512-2.679 2.512-1.269 0-2.009-.75-1.974-1.99C9.789 1.436 10.67 0 12.432 0zM8.309 20c-1.058 0-1.833-.652-1.093-3.524l1.214-5.092c.211-.814.246-1.141 0-1.141-.317 0-1.689.562-2.502 1.117l-.528-.88c2.572-2.186 5.531-3.467 6.801-3.467 1.057 0 1.233 1.273.705 3.23l-1.391 5.352c-.246.945-.141 1.271.106 1.271.317 0 1.357-.392 2.379-1.207l.6.814C12.098 19.02 9.365 20 8.309 20z" })
], -1))
const _hoisted_27 = { style: {"white-space":"pre-line"} }
const _hoisted_28 = { class: "flex items-center px-4 py-3 mt-2 w-full" }
const _hoisted_29 = {
  key: 2,
  class: "fade-in"
}
const _hoisted_30 = { class: "mt-8" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_32 = {
  key: 0,
  class: "flex items-center justify-center"
}
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "w-24 h-20 mr-4 p-3 br8" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "bg-white",
    alt: "visa secure logo",
    src: _imports_3
  })
], -1))
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "w-24 h-20 mr-4 p-3 br8" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "bg-white",
    alt: "mastercard identity check logo",
    src: _imports_4
  })
], -1))
const _hoisted_35 = [
  _hoisted_33,
  _hoisted_34
]
const _hoisted_36 = {
  key: 1,
  class: "flex justify-center flex-col items-center sm:w-full sm:p-6"
}
const _hoisted_37 = { class: "text-center text-3xl not-italic font-semibold mt-4 mb-4" }
const _hoisted_38 = { class: "text-pink-400 text-center text-lg not-italic font-medium w-4/5 mb-12" }
const _hoisted_39 = { class: "buttomError cursor-pointer walletButton flex justify-center items-center p-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SvgContainer = _resolveComponent("SvgContainer")!
  const _component_ColorButton = _resolveComponent("ColorButton")!
  const _component_RedsysForm = _resolveComponent("RedsysForm")!
  const _component_StripeForm = _resolveComponent("StripeForm")!
  const _component_AzulForm = _resolveComponent("AzulForm")!
  const _component_TransbankForm = _resolveComponent("TransbankForm")!
  const _component_MercadoPagoForm = _resolveComponent("MercadoPagoForm")!
  const _component_RazorpayForm = _resolveComponent("RazorpayForm")!
  const _component_BridgerPayForm = _resolveComponent("BridgerPayForm")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_PopUpLight = _resolveComponent("PopUpLight")!
  const _component_router_link = _resolveComponent("router-link")!
  const _directive_disable_on_click = _resolveDirective("disable-on-click")!

  return (_openBlock(), _createElementBlock("span", null, [
    (_ctx.paymentData.paymentProviderData !== undefined)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass([{ 'mt-8 overflow-y-hidden': _ctx.isWebView, whiteTheme: _ctx.isWhiteTheme }, "flex justify-center"])
        }, [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              ((_ctx.cards.length > 0 || _ctx.canUseVoucher) && !_ctx.canPay)
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.$t("payment_methods").toUpperCase()), 1))
                : _createCommentVNode("", true),
              (_ctx.canUseVoucher && !_ctx.canPay)
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    _createElementVNode("div", {
                      class: _normalizeClass(["flex flex-col justify-between w-full bg-zinc-700 cardOption p-4 mb-6 walletButton", { 'disabledButton': _ctx.voucherSelected === false }]),
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (((_ctx.showVoucherWarning && !_ctx.isSharedPayment()) || (!_ctx.showVoucherWarning)) && _ctx.userSelectedPay(true)))
                    }, [
                      _createElementVNode("div", _hoisted_5, [
                        _hoisted_6,
                        _createElementVNode("div", null, [
                          _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.$t("pay_with_bonus")), 1)
                        ])
                      ]),
                      (_ctx.paymentDeadLine !== '' && _ctx.voucherSelected || (_ctx.showVoucherWarning && _ctx.isSharedPayment()))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                            _createElementVNode("p", null, _toDisplayString(_ctx.getVoucherSharePaymentText()), 1)
                          ]))
                        : _createCommentVNode("", true)
                    ], 2)
                  ]))
                : _createCommentVNode("", true),
              (!(_ctx.cards.length > 0) && !_ctx.canPay)
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                    _createElementVNode("div", {
                      class: _normalizeClass(["flex flex-col justify-between w-full bg-zinc-700 cardOption p-4 mb-6 walletButton", { 'disabledButton': _ctx.voucherSelected === true }]),
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.userSelectedPay(false)))
                    }, [
                      _createElementVNode("div", _hoisted_10, [
                        _hoisted_11,
                        _createElementVNode("div", null, [
                          _createElementVNode("p", _hoisted_12, _toDisplayString(_ctx.$t("pay_with_card")), 1)
                        ])
                      ])
                    ], 2)
                  ]))
                : _createCommentVNode("", true),
              (!_ctx.canPay)
                ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cards, (card) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: _normalizeClass(["flex justify-between w-full bg-zinc-700 cardOption p-4 items-center mb-6", {
                walletButton: _ctx.cardId === card.token,
                disabledButton: _ctx.voucherSelected === true
              }]),
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.userSelectedPay(false))),
                        key: card.token
                      }, [
                        _createElementVNode("div", _hoisted_14, [
                          _createElementVNode("div", _hoisted_15, [
                            _createElementVNode("img", {
                              alt: card.brand,
                              src: card.logoUrl
                            }, null, 8, _hoisted_16)
                          ]),
                          _createElementVNode("div", null, [
                            _createElementVNode("p", _hoisted_17, _toDisplayString(card.brand), 1),
                            _createElementVNode("p", _hoisted_18, " **** **** **** " + _toDisplayString(_ctx.getLast4Digits(card.number || "")), 1)
                          ])
                        ]),
                        _createElementVNode("div", {
                          class: "cursor-pointer deleteCard p-4 br100",
                          onClick: ($event: any) => (_ctx.deleteCard(card.id!, $event))
                        }, [
                          _createVNode(_component_SvgContainer, { name: "deleteCard" })
                        ], 8, _hoisted_19)
                      ], 2))
                    }), 128))
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_20, [
                (_ctx.showPolicy)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: _normalizeClass(["checkoutPolicy cursor-pointer mt-5 pb-4", { openPolicity: _ctx.openLegal }]),
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.openLegal = !_ctx.openLegal))
                    }, [
                      _createElementVNode("div", _hoisted_21, [
                        _createElementVNode("div", _hoisted_22, _toDisplayString(_ctx.cancellation_policy), 1),
                        _hoisted_23
                      ]),
                      _createElementVNode("div", _hoisted_24, _toDisplayString(_ctx.cancellation_policy_full) + " " + _toDisplayString(_ctx.cancellationLimitStr), 1)
                    ], 2))
                  : _createCommentVNode("", true),
                (_ctx.paymentDeadLine !== '')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                      _hoisted_26,
                      _createElementVNode("p", _hoisted_27, _toDisplayString(_ctx.getSharePaymentText()), 1)
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_28, [
                  (_ctx.redsysData === null && _ctx.mercadoPagoData === null && _ctx.stripeData === null && _ctx.azulData === null && _ctx.razorpayData === null && !_ctx.showAppLoading)
                    ? _withDirectives((_openBlock(), _createBlock(_component_ColorButton, {
                        key: 0,
                        text: _ctx.getPayText(),
                        onClick: _ctx.payWithSelectedMethod,
                        class: "md:mt-8 sm:mt-4 sm:mb-4 playerSubtitle forceWhite"
                      }, null, 8, ["text", "onClick"])), [
                        [_directive_disable_on_click, void 0, "pay"]
                      ])
                    : _createCommentVNode("", true)
                ]),
                (_ctx.showAppLoading)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                      _createElementVNode("p", null, _toDisplayString(_ctx.$t("connecting_to_bank")), 1)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createVNode(_Transition, null, {
                default: _withCtx(() => [
                  (_ctx.redsysData !== null)
                    ? (_openBlock(), _createBlock(_component_RedsysForm, {
                        key: 0,
                        redsysData: _ctx.redsysData,
                        onPaymentExecuted: _ctx.paymentExecuted,
                        storeCard: true,
                        onlyStoreCard: _ctx.onlyStoreCard,
                        cardId: _ctx.cardId,
                        ref: "redsysFormRef"
                      }, null, 8, ["redsysData", "onPaymentExecuted", "onlyStoreCard", "cardId"]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }),
              _createVNode(_Transition, null, {
                default: _withCtx(() => [
                  (_ctx.stripeData)
                    ? (_openBlock(), _createBlock(_component_StripeForm, {
                        key: 0,
                        data: _ctx.stripeData,
                        user: _ctx.user,
                        onPaymentExecuted: _ctx.paymentExecuted,
                        cardId: _ctx.cardId
                      }, null, 8, ["data", "user", "onPaymentExecuted", "cardId"]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }),
              _createVNode(_Transition, null, {
                default: _withCtx(() => [
                  (_ctx.azulData)
                    ? (_openBlock(), _createBlock(_component_AzulForm, {
                        key: 0,
                        data: _ctx.azulData,
                        user: _ctx.user,
                        onPaymentExecuted: _ctx.paymentExecuted,
                        cardId: _ctx.cardId
                      }, null, 8, ["data", "user", "onPaymentExecuted", "cardId"]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }),
              _createVNode(_Transition, null, {
                default: _withCtx(() => [
                  (_ctx.transbankData)
                    ? (_openBlock(), _createBlock(_component_TransbankForm, {
                        key: 0,
                        data: _ctx.transbankData,
                        user: _ctx.user,
                        onPaymentExecuted: _ctx.paymentExecuted,
                        cardId: _ctx.cardId
                      }, null, 8, ["data", "user", "onPaymentExecuted", "cardId"]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }),
              _createVNode(_Transition, null, {
                default: _withCtx(() => [
                  (_ctx.mercadoPagoData !== null)
                    ? (_openBlock(), _createBlock(_component_MercadoPagoForm, {
                        key: 0,
                        data: _ctx.mercadoPagoData,
                        user: _ctx.user,
                        onPaymentExecuted: _ctx.paymentExecuted,
                        cardId: _ctx.cardId
                      }, null, 8, ["data", "user", "onPaymentExecuted", "cardId"]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }),
              _createVNode(_Transition, null, {
                default: _withCtx(() => [
                  (_ctx.razorpayData)
                    ? (_openBlock(), _createBlock(_component_RazorpayForm, {
                        key: 0,
                        data: _ctx.razorpayData,
                        user: _ctx.user,
                        onPaymentExecuted: _ctx.paymentExecuted,
                        cardId: _ctx.cardId
                      }, null, 8, ["data", "user", "onPaymentExecuted", "cardId"]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }),
              _createVNode(_Transition, null, {
                default: _withCtx(() => [
                  (_ctx.bridgerPayData)
                    ? (_openBlock(), _createBlock(_component_BridgerPayForm, {
                        key: 0,
                        data: _ctx.bridgerPayData,
                        saleId: _ctx.saleId,
                        onPaymentExecuted: _ctx.paymentExecuted,
                        cardId: _ctx.cardId
                      }, null, 8, ["data", "saleId", "onPaymentExecuted", "cardId"]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }),
              _createVNode(_Transition, null, {
                default: _withCtx(() => [
                  (_ctx.getCvvPopup)
                    ? (_openBlock(), _createBlock(_component_PopUpLight, {
                        key: 0,
                        onClosed: _cache[6] || (_cache[6] = ($event: any) => (_ctx.getCvvPopup = false)),
                        customClass: 'width-xsm'
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_30, [
                            _createVNode(_component_InputText, {
                              modelValue: _ctx.cvv,
                              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.cvv) = $event)),
                              placeholder: `CVV`
                            }, null, 8, ["modelValue"]),
                            _hoisted_31,
                            _createElementVNode("div", {
                              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.cvvOkClicked())),
                              class: "flex justify-center filledButton md:mt-8 sm:mt-4 cursor-pointer sm:w-full"
                            }, _toDisplayString(_ctx.$t("text_continue")), 1)
                          ])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]),
            (_ctx.show3DLogos)
              ? (_openBlock(), _createElementBlock("div", _hoisted_32, _hoisted_35))
              : _createCommentVNode("", true)
          ])
        ], 2))
      : _createCommentVNode("", true),
    (_ctx.saleIsPaid)
      ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
          _createElementVNode("p", _hoisted_37, _toDisplayString(_ctx.$t("oh_no")), 1),
          _createElementVNode("p", _hoisted_38, _toDisplayString(_ctx.$t("purchase_was_successful")), 1),
          _createVNode(_component_router_link, { to: "/" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_39, _toDisplayString(_ctx.$t("back_to_home")), 1)
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true)
  ]))
}